// @ts-nocheck



import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { fetchRequest } from './index';

export const convertDataToServer = (writeOffAct) => ({
  ...writeOffAct,
  sum: convertFromRubToKop(writeOffAct.sum)
});

export const convertDataFromServer = (
writeOffAct) => (
{
  ...writeOffAct,
  sum: convertFromKopToRub(writeOffAct.sum)
});

const basedUrl = 'writeOffAct';
const writeOffAct = new CommonApi(
  basedUrl,
  'акт списания МПЗ',
  convertDataToServer,
  convertDataFromServer
);

export const addSeparateAct = async (
data) =>
{
  const writeOffAct = await fetchRequest.post(`/${basedUrl}/separateAct`, data);
  if (writeOffAct) {
    return convertDataFromServer(writeOffAct);
  }
  throw new Error('Не удалось сформировать акт списания МПЗ');
};

export default {
  ...writeOffAct,
  addSeparateAct
};
